import { createContext, useEffect, useState } from 'react';
import { getDataFromTurbinePPComposedAssetId } from '../utils/utils';
import { useParams } from 'react-router-dom';

export const ComponentContext = createContext({
  component: null,
  setComponent: () => {},
  asset: null,
  setAsset: () => {},
  latestAssetStatus: null,
  setLatestAssetStatus: () => {},
  isLatestAsset: null,
  refetch: null,
  setRefetch: () => {}
});

function NRComponentContextWrapper({ children }) {
  const { componentId } = useParams();
  const [component, setComponent] = useState(null);
  const [asset, setAsset] = useState(null);
  const [latestAssetStatus, setLatestAssetStatus] = useState(null);
  const [currentAssetStatus, setCurrentAssetStatus] = useState(null);
  const [isLatestAsset, setIsLatestAsset] = useState(null);
  const [refetch, setRefetch] = useState(false);

  useEffect(() => {
    if (!!asset?.id && !!latestAssetStatus?.assetId) {
      const { assetId: latestStatusAssetId, revision: latestStatusRevision } = getDataFromTurbinePPComposedAssetId(latestAssetStatus.assetId);
      const { assetId: urlAssetId, revision: urlRevision } = getDataFromTurbinePPComposedAssetId(componentId);

      if (!!latestAssetStatus && currentAssetStatus?.assetId !== latestAssetStatus.assetId) {
        setCurrentAssetStatus(latestAssetStatus);
      }
      setIsLatestAsset(
        latestStatusAssetId === urlAssetId &&
          latestStatusRevision === urlRevision &&
          currentAssetStatus?.lastUpdatedTime == latestAssetStatus?.lastUpdatedTime
      );
      // Si las fechas son iguales, es la ultima version
      // Si las fechas no son iguales, tengo que mostrar el cartel de refresh page
    }
  }, [latestAssetStatus, asset, currentAssetStatus]);

  const defaultValues = {
    component,
    setComponent,
    asset,
    setAsset,
    latestAssetStatus,
    setLatestAssetStatus,
    isLatestAsset,
    refetch,
    setRefetch
  };

  return <ComponentContext.Provider value={defaultValues}>{children}</ComponentContext.Provider>;
}

export default NRComponentContextWrapper;
